export default "__VITE_ASSET__B38Cxqi9__"